(function () {
    const newsListingWrap = document.querySelector('.section-news-listing .row');

    if(newsListingWrap){
        pagination();
    }

    // Pagination function
    function pagination() {
        let pagination = document.querySelectorAll(".pagination.news-listing .page-link");
        for (let i = 0; i < pagination.length; i++) {
        pagination[i].addEventListener("click", function (e) {
            e.preventDefault();
            let pageNo = pagination[i].getAttribute("data-pageno");
            newsListing(pageNo);
        });
        }
    }

    // Newslisting function
    function newsListing(page = 1) {
        if(newsListingWrap){
            newsListingWrap.innerHTML += '<div id="loading" class="show"><div class="loader"></div></div>';
        }

        // Page data to send in request
        let pageData = "&pageNo=" + page;
        let pageUrlValue = document.getElementById('page-url-news-listing').value;
        pageUrl = "&pageurl=" + pageUrlValue;

        // Ajax request
        let request = new XMLHttpRequest();
        request.open("POST", metz_ajax_callback_data.ajax_url, true);
        request.setRequestHeader(
        "Content-Type",
        "application/x-www-form-urlencoded; charset=UTF-8"
        );
        
        request.onreadystatechange = () => {
            if (request.readyState === 4) {
                const loadMoreGif = document.querySelector("#loading");
                if(loadMoreGif){
                    loadMoreGif.remove();
                }
                const responseData = JSON.parse(request.response);
                if (responseData.data.output === 'no-items' && totalTiles) {
                    responseHtml = '<span class="no-result">No Results Found</span>';
                }
                else {
                    responseHtml = responseData.data.output;
                }
                if(newsListingWrap){
                    newsListingWrap.innerHTML = responseHtml;
                }
                pagination();
            }
        };
        request.send(
        "action=newslisting&nonce=" +
            metz_ajax_callback_data.ajax_nonce +
            pageData +
            pageUrl
        );
    }
})();